import { parseISO, isBefore, startOfDay } from 'date-fns';

export type EmployeeStatus = 'current' | 'future' | 'past';

export const isFutureStart = (startDate?: string | null): boolean =>
  !!startDate && !isBefore(parseISO(startDate), startOfDay(new Date()));

export const getEmployeeStatus = (employee: {
  flair__Active__c?: boolean | null;
  flair__Start_Date__c?: string | null;
  flair__End_Date__c?: string | null;
}): EmployeeStatus => {
  const isActive = employee.flair__Active__c ?? true;

  if (!isActive && isFutureStart(employee.flair__Start_Date__c)) {
    return 'future';
  }
  if (
    !isActive &&
    employee.flair__End_Date__c &&
    isBefore(parseISO(employee.flair__End_Date__c), startOfDay(new Date()))
  ) {
    return 'past';
  }
  return 'current';
};
